(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    /* Den klaebende koebebjaelke kommer frem naar den RIGTIGE koebeknap er rullet
       OP forbi skaermen, og gaar vaek igen naar den er tilbage.

       INTERSECTIONOBSERVER DUER IKKE HER, og det er vaerd at vide hvorfor:
       observeren fyrer kun naar et element KRYDSER en taerskel. Springer siden
       fra "knappen ligger under skaermen" til "knappen ligger over skaermen" i ét
       ryk — et anker-link, en gendannet rulleposition, eller bare en hurtig
       swipe — saa er forholdet 0 baade foer og efter, ingen taerskel bliver
       krydset, og callbacket kommer aldrig. Maalt paa rev 283: bjaelken kom
       ALDRIG frem naar man sprang direkte forbi knappen.

       Derfor en rulle-lytter, klemt sammen med requestAnimationFrame saa der
       hoejst regnes én gang pr. billede. Det er to sammenligninger; det er
       billigere end den fejl det erstatter.

       De 96px er bjaelkens egen hoejde plus lidt luft: uden dem ville bjaelken
       daekke knappen, knappen ville taelle som ude af syne, og de to ville blinke
       mod hinanden. */
    function initStickyBuy() {
      var bar = document.querySelector("[data-sticky-buy]");
      var form = document.getElementById("pdp-buy-form");
      if (!bar || !form) return;
      var venter = false;
      var maal = function () {
        venter = false;
        var r = form.getBoundingClientRect();
        // knappens underkant er over skaermens top = den er rullet forbi
        bar.hidden = r.bottom > 96;
      };
      var paaRul = function () {
        if (venter) return;
        venter = true;
        requestAnimationFrame(maal);
      };
      window.addEventListener("scroll", paaRul, { passive: true });
      window.addEventListener("resize", paaRul, { passive: true });
      maal();
    }

    function init(root) {
      // Qty + dynamic total
      document.querySelectorAll('.pdp__buy').forEach(function (form) {
        var input = form.querySelector('[data-qty-input]');
        var minus = form.querySelector('[data-qty-minus]');
        var plus = form.querySelector('[data-qty-plus]');
        var totalEl = form.querySelector('[data-cart-total]');
        var fmt = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', maximumFractionDigits: 0 });
        function render() {
          // Enhedsprisen læses ved HVERT render: campaign-live.js kan sænke
          // data-unit-price når varen har en aktiv kampagnerabat.
          var unit = parseInt(form.getAttribute('data-unit-price') || '0', 10); // cents
          var q = parseInt(input.value || '1', 10);
          if (totalEl) totalEl.textContent = fmt.format((unit * q) / 100);
        }
        if (minus) minus.addEventListener('click', function () {
          var q = Math.max(1, parseInt(input.value || '1', 10) - 1); input.value = q; render();
        });
        if (plus) plus.addEventListener('click', function () {
          var q = parseInt(input.value || '1', 10) + 1; input.value = q; render();
        });
        render();
      });
      // Gallery: click a thumbnail to change the main image
      document.querySelectorAll('.pdp__gallery').forEach(function (g) {
        var main = g.querySelector('.pdp__main-image img');
        var thumbs = g.querySelectorAll('.pdp__thumb');
        if (!main || thumbs.length < 2) return;
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            var full = t.getAttribute('data-full');
            var filter = t.getAttribute('data-filter');
            if (full) { main.removeAttribute('srcset'); main.src = full; }
            if (filter !== null) { main.style.filter = filter; }
            thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          });
        });
      });
      // Sticky gallery: pin it below the ACTUAL sticky header (measured live, so it
      // survives cat-nav wrapping / viewport differences that the fixed CSS heights miss).
      var stickyHeader = document.querySelector('.shopify-section-group-header-group');
      function syncGalleryOffset() {
        var h = stickyHeader ? stickyHeader.offsetHeight : 0;
        /* Servicebåndet er rullet væk længe før galleriet når sin klæbeplads (headeren
           klæber på et negativt top svarende til båndets højde), så det tæller ikke med
           i det galleriet skal holde sig fri af. Højden måles på båndet selv i stedet
           for at læses ud af variablen: er båndet tomt eller skjult, er der intet at
           trække fra, og så bliver regnestykket rigtigt af sig selv. */
        var utility = stickyHeader ? stickyHeader.querySelector('.site-header__utility') : null;
        if (utility) h -= utility.offsetHeight;
        if (h > 0) document.documentElement.style.setProperty('--pdp-gallery-top', (h + 24) + 'px');
      }
      if (stickyHeader && !window.__pdpGallerySyncBound) {
        window.__pdpGallerySyncBound = true;
        syncGalleryOffset();
        window.addEventListener('load', syncGalleryOffset);
        window.addEventListener('resize', syncGalleryOffset);
      }
      // === ANDRE FRA MAERKET ===
      // Henter maerkets varer fra Shopifys vendor-collection gennem den lette
      // brandkort-template. Se kommentaren i markuppen for hvorfor det ikke kan
      // goeres i Liquid.
      document.querySelectorAll('[data-brandmere]').forEach(function (sek) {
        var gitter = sek.querySelector('[data-brandmere-gitter]');
        if (!gitter || gitter.children.length) return;   // ExecHtml kan koere init to gange
        var vendor = sek.getAttribute('data-vendor') || '';
        var egen = sek.getAttribute('data-handle') || '';
        if (!vendor) return;

        fetch('/collections/vendors?q=' + encodeURIComponent(vendor) + '&view=brandkort', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var kort = [].slice.call(doc.querySelectorAll('.product-card'));
            var valgt = kort.filter(function (k) {
              // Varen man staar paa skal ikke anbefale sig selv. Fillers hoerer
              // til gitterets egen udfyldning og har intet produkt.
              return k.getAttribute('data-handle') !== egen &&
                     !k.classList.contains('product-card--filler');
            }).slice(0, 4);
            if (!valgt.length) return;   // ét-vare-maerke: sektionen bliver skjult
            valgt.forEach(function (k) { gitter.appendChild(document.importNode(k, true)); });
            sek.removeAttribute('hidden');
            // Hjerterne males ikke af sig selv paa markup der kom efter load.
            if (window.EndorseLikes && window.EndorseLikes.paint) window.EndorseLikes.paint(gitter);
          })
          .catch(function () { /* hylden er en anbefaling, ikke noget siden mangler */ });
      });

      // Tabs
      document.querySelectorAll('[data-pdp-tabs]').forEach(function (tabs) {
        var btns = tabs.querySelectorAll('.pdp__tab');
        var panels = tabs.querySelectorAll('.pdp__panel');

        function vaelg(b, flytFokus) {
          var id = b.getAttribute('data-tab');
          btns.forEach(function (x) {
            var aktiv = x === b;
            x.classList.toggle('is-active', aktiv);
            // ARIA saettes kun hvis fanen ER en fane. De gamle legacy-faner har
            // ingen roller, og et halvt sat aria-selected er vaerre end ingen.
            if (x.hasAttribute('role')) {
              x.setAttribute('aria-selected', aktiv ? 'true' : 'false');
              x.tabIndex = aktiv ? 0 : -1;
            }
          });
          panels.forEach(function (p) {
            var aktiv = p.getAttribute('data-panel') === id;
            p.classList.toggle('is-active', aktiv);
            if (p.hasAttribute('role')) { if (aktiv) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); }
          });
          if (flytFokus) b.focus();
        }

        btns.forEach(function (b, i) {
          b.addEventListener('click', function () { vaelg(b, false); });
          // Pilenavigation. Et tablist uden den er ikke en tablist for nogen der
          // ikke bruger mus.
          b.addEventListener('keydown', function (e) {
            if (!b.hasAttribute('role')) return;
            var n = null;
            if (e.key === 'ArrowRight') n = btns[(i + 1) % btns.length];
            else if (e.key === 'ArrowLeft') n = btns[(i - 1 + btns.length) % btns.length];
            else if (e.key === 'Home') n = btns[0];
            else if (e.key === 'End') n = btns[btns.length - 1];
            if (n) { e.preventDefault(); vaelg(n, true); }
          });
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); initStickyBuy(); });
    } else {
      init(document);
      initStickyBuy();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
